import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ListDataDto } from '../../core/common/list-data-dto';

export interface ConvencaoSindicalDocumentoDto {
  id: string;
  executionId: string;
  botId: string;
  fileName: string;
  contentType: string;
  storagePath: string;
  sizeBytes: number;
  hash?: string | null;
  uploadedAt: string;
  tags: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ConvencoesSindicaisService {
  private readonly botId = 'convencao-sindical-documentos';
  private readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/convencoes-sindicais`;

  constructor(private readonly http: HttpClient) {}

  getList(
    page: number,
    pageSize: number,
    botId = this.botId,
    filtros: { uf?: string; cidade?: string } = {}
  ): Observable<ListDataDto> {
    let params = new HttpParams()
      .set('botId', botId)
      .set('page', page)
      .set('pageSize', pageSize);

    if (filtros.uf) {
      params = params.set('uf', filtros.uf);
    }

    if (filtros.cidade) {
      params = params.set('cidade', filtros.cidade);
    }

    return this.http.get<ListDataDto>(this.serviceApi, { params });
  }

  getFile(id: string): Observable<Blob> {
    return this.http.get(`${this.serviceApi}/${id}/arquivo`, {
      responseType: 'blob'
    });
  }

  gerarRelatorio(uf: string, cidade?: string): Observable<Blob> {
    let params = new HttpParams().set('uf', uf);

    if (cidade) {
      params = params.set('cidade', cidade);
    }

    return this.http.get(`${this.serviceApi}/relatorio`, {
      params,
      responseType: 'blob'
    });
  }
}
